import {Auth} from "@digatex/digatex-ui-lib";
import {createRoot} from "react-dom/client";

import {JIRA_DATA_KEY} from "./entities/properties";

import App from "./app/App";
import {App as AntApp} from "antd";

import "@/main.css";

function jiraHelpdesk(callback: () => void) {
	if (!JIRA_DATA_KEY) {
		console.error("JIRA_DATA_KEY undefined");
		return;
	}
	const jhdScript = document.createElement("script");
	jhdScript.type = "text/javascript";
	jhdScript.setAttribute("data-jsd-embedded", "");
	jhdScript.setAttribute("data-key", JIRA_DATA_KEY);
	jhdScript.setAttribute("data-base-url", "https://jsd-widget.atlassian.com");
	jhdScript.src = "https://jsd-widget.atlassian.com/assets/embed.js";

	jhdScript.onload = function () {
		callback();
	};

	jhdScript.onerror = function () {
		console.error("Error loading script JIRA Helpdesk.");
	};

	document.head.appendChild(jhdScript);
}

jiraHelpdesk(function () {
	const DOMContentLoaded_event = new Event("DOMContentLoaded", {bubbles: true, cancelable: true});
	window.document.dispatchEvent(DOMContentLoaded_event);
});

Auth.init(() => createRoot(document.getElementById("root")!).render(<AntApp><App /></AntApp>));
